import { render, staticRenderFns } from "./goodsItems.vue?vue&type=template&id=7ad67b12&scoped=true&"
import script from "./goodsItems.vue?vue&type=script&lang=js&"
export * from "./goodsItems.vue?vue&type=script&lang=js&"
import style0 from "./goodsItems.vue?vue&type=style&index=0&id=7ad67b12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad67b12",
  null
  
)

export default component.exports